import { getDate } from "@poseidon/firebase/timestamp";

export const mapAddress = (snapshot) => {
  const data = snapshot.data();
  return {
    ...data,
    id: snapshot.id,
    from: getDate(data.from),
    to: getDate(data.to),
    current: data.current || false,
  };
};
